<template>
  <div class="step-container scrollPosition result-page">
    <div class="step-header">
      <h2 class="step-title">Danke für Ihre Anfrage</h2>
      <p class="step-text">
        Sie erhalten in Kürze einen Link zu Ihrer gewünschten
        Immobilienkalkulation.
      </p>
    </div>
    <!-- <div class="verkehrswert">
      € {{ formatPrice(vonVerkehrswert) }} - {{ formatPrice(bisVerkehrswert) }}
    </div>
    <div class="info-text">
      Die angegebene Bandbreite ist ein Richtwert, den wir auf Basis Ihrer
      Angaben errechnet haben. Sie ersetzt keine professionelle
      Immobilienbewertung. Für die Umsetzung Ihres Vorhabens wenden Sie sich
      bitte an Ihre Kundenbetreuer:in.
    </div> -->
    <div class="step-footer d-print-none">
      <div class="row align-items-center">
        <div class="col-md-4 col-12 start-container">
          <button
            class="back-btn"
            @click="goToStart()"
          >
            Neuen Immobilien-Check starten
          </button>
        </div>
        <!-- <div class="col-md-4 col-12 next-container">
          <button class="home-btn" @click="print()">Drucken</button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Constants from "@/constants.js";
import { clearStorage } from "@/utils.js";
export default {
  name: "reihenhaus-step-11b",
  methods: {
    goToStart() {
      this.$router.push("/start");
    },
    print() {
      window.print();
    },
    formatPrice(number) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    },
  },
  data() {
    return {
      vonVerkehrswert: "",
      bisVerkehrswert: "",
    };
  },
  mounted() {
    this.$emit("setStep", "reihenhaus", 13);
    this.vonVerkehrswert = sessionStorage.getItem(
      Constants.PREFIX + ".vonVerkehrswert"
    );
    this.bisVerkehrswert = sessionStorage.getItem(
      Constants.PREFIX + ".bisVerkehrswert"
    );
    clearStorage();
  },
};
</script>
